export default __webpack_public_path__ + "661bc2f1e947c779dafbcf2a23ebde9b.svg";